export default {
  welcome                                                                   : "HALLO",
  home                                                                      : "BETALING",
  application                                                               : "BETAAL JE FACTUREN VEILIG",
  service                                                                   : "WIJ ACCEPTEREN",
  adyenInfo                                                                 : "Adyen is een internationaal betalingsbedrijf dat handelaars online diensten aanbiedt om elektronische betalingen te accepteren via betaalmethoden zoals creditcards, bankbetalingen zoals betaalkaarten, bankoverschrijvingen en elektronische overboekingen. realtime op basis van online bankieren.",
  paypalInfo                                                                : "PayPal is een online betaaldienst waarmee u kunt betalen voor aankopen, betalingen kunt ontvangen of geld kunt verzenden en ontvangen. Om van deze services te profiteren, moet een persoon een account maken en vervolgens verschillende bankgegevens naar PayPal verzenden, zoals het creditcardnummer.",
  transferInfo                                                              : "Bij bankoverschrijving gaat het om het overboeken van geld van de ene naar de andere bankrekening. De rekening waarvan het geld wordt opgenomen, wordt gedebiteerd en de rekening waarop het geld wordt gestort, wordt gecrediteerd.",
  signIn                                                                    : "Aanmelden / Inschrijven",
  continue                                                                  : "Klik zodra u bent verbonden op",
  onlinePayment                                                             : "Online betaling",
  onlinePaymentInfo                                                         : "Ons systeem ondersteunt betaling door Discover, American Express, Maestro, Diners Club, Master Card en Visa.",
  "About us"                                                                : "Over ons",
  owrApps                                                                   : "OWR Apps",
  pageNotFound                                                              : "Oeps, zou deze pagina kan niet gevonden!",
  yourorder                                                                 : "UW BESTELLING",
  onlineCardTitle                                                           : "ONLINE BETALING",
  transferCardTitle                                                         : "Bankoverdracht",
  goBackToHome                                                              : "Ga terug naar de startpagina",
  logout                                                                    : "uitloggen",
  help                                                                      : "helpen",
  Communities                                                               : "Gemeenschappen",
  campaigns                                                                 : "Campagnes",
  webPage                                                                   : "webpagina",
  modifyOrder                                                               : "Wijzig mijn registratie",
  previous                                                                  : "Voorgaand",
  vatRate                                                                   : "Btw Tarief",
  next                                                                      : "Volgend",
  filter                                                                    : "Filter",
  status                                                                    : "Staat",
  DRAFT                                                                     : "ONTWERP",
  return                                                                    : "Terugkeer",
  comingSoon                                                                : "BINNENKORT",
  transferReminder                                                          : "Om een bevestiging van uw inschrijving te ontvangen, moet u bij de overschrijving de juiste gestructureerde mededeling (VCS) vermelden. U kan ook online betalen, dan krijgt u onmiddellijk een bevestiging.",
  SENT                                                                      : "VERZONDEN",
  ordersHistory                                                             : "BESTEL GESCHIEDENIS",
  paidOrders                                                                : "Betaalde bestellingen",
  organization                                                              : "Organisatie",
  street                                                                    : "Straat",
  number                                                                    : "Aantal",
  country                                                                   : "België, Marokko",
  locality                                                                  : "Plaats",
  postalCode                                                                : "Postcode",
  creditNotes                                                               : "Creditnota's",
  creditNotesList                                                           : "CREDIT NOTES LIJST",
  journal                                                                   : "Dagboek\n",
  supplement                                                                : "Supplement",
  refundAccount                                                             : "Restitutie account",
  refundStatus                                                              : "Restitutiestatus",
  comment                                                                   : "Commentaar",
  app                                                                       : "App",
  purchaseOrder                                                             : "Bestelling",
  invoice                                                                   : "Factuur",
  docType                                                                   : "Type document",
  unpaidOrders                                                              : "Onbetaalde bestellingen",
  CREATED                                                                   : "CREËERT",
  language                                                                  : "Taal",
  reset                                                                     : "Reset",
  searchBySubject                                                           : "Zoek op onderwerp",
  choseIban                                                                 : "Kies eerst een Iban",
  addNewIban                                                                : "Voeg een nieuwe Iban toe",
  issuerInvoices                                                            : "Jouw facturen",
  subject                                                                   : "Subject",
  cancel                                                                    : "ANNULEER",
  save                                                                      : "Opslaan",
  codeOwn                                                                   : "je eigen code",
  createdAt                                                                 : "Gemaakt bij",
  groups                                                                    : "Groepen",
  recipients                                                                : "Ontvangers",
  sent                                                                      : "Verzending",
  enterText                                                                 : "Voer tekst ...",
  deleteCampaignConfirm                                                     : "Wil je echt wilt de campagne wilt verwijderen?",
  delete                                                                    : "verwijderen",
  fromEmail                                                                 : "van email",
  order_details                                                             : "Details van de bestelling:",
  preVatAmount                                                              : "Bedrag voor btw",
  vatAmount                                                                 : "BTW bedrag",
  includedVatAmount                                                         : "Bedrag incl. btw",
  lines_details                                                             : "De details van de opdrachtregel",
  description                                                               : "Beschrijving",
  price                                                                     : "Prijs",
  quantity                                                                  : "Hoeveelheid",
  paymentAccepted                                                           : "Betaling geaccepteerd",
  thanks                                                                    : "Bedankt",
  invoiceTo                                                                 : "U ontvangt een e-mail met uw factuur naar dit vak",
  adyenErr                                                                  : "U ontvangt een e-mail met uw factuur naar dit vak",
  loading                                                                   : "Bezig met laden ...",
  paymentRefused                                                            : "Betaling geweigerd",
  fromName                                                                  : "van naam",
  replyTo                                                                   : "antwoord aan",
  recipientType                                                             : "Ontvanger Type",
  confirmation                                                              : "Bevestiging",
  moreErrordetails                                                          : "Meer details",
  validationMsg                                                             : "Wil je doorgaan? Zo ja, klik dan op Valideren",
  typeTestEmail                                                             : "Typ de auquelles mail adressen die u wilt op de proef te sturen",
  warning                                                                   : "warning",
  groupsIncluded                                                            : "groepen opgenomen",
  excludedGroups                                                            : "GROEPEN UITGESLOTEN",
  selectGroups                                                              : "Selecteer Groepen",
  paymentPending                                                            : "Niet mogelijk om de definitieve status van de betaling te verkrijgen. U moet verdere actie ondernemen om de betaling te voltooien.",
  paymentCancelled                                                          : "De betaling is geannuleerd voordat deze is voltooid.",
  paymentError                                                              : "Er is een fout opgetreden tijdens de verwerking van de betaling.",
  paymentRefusedApi                                                         : "De betaling werd geweigerd. Betalingsautorisatie was niet succesvol.",
  excludeGroups                                                             : "uitsluiten groepen",
  "Select event"                                                            : "Selecteer evenement",
  "Select activities"                                                       : "Selecteer activiteiten",
  "Exclude activities"                                                      : "Activiteiten uitsluiten",
  "Select status"                                                           : "Selecteer de status",
  "Exclude status"                                                          : "Status uitsluiten",
  sendTitle                                                                 : "Je staat op het punt om een campagne naar te sturen",
  tested                                                                    : "getest",
  attachments                                                               : "toebehoren",
  confirm                                                                   : "BEVESTIGEN",
  confirmSendCampaign                                                       : "Weet u zeker dat u deze campagne wilt verzenden?",
  noNotNow                                                                  : "NEE, NIET NU",
  yesSend                                                                   : "JA, ZEND",
  sendTestTo                                                                : "Stuur de test",
  sendTest                                                                  : "STUUR TEST",
  send                                                                      : "sturen",
  PLAIN_TEXT                                                                : "TEKST",
  WEB_PAGE                                                                  : "WEB PAGINA",
  selectTarget                                                              : "Selecteer gerichte doelgroepen",
  campaignInfo                                                              : "Campagne info",
  invalidObject                                                             : "object moet minimaal 5 tekens bevatten en mag niet meer dan 200 tekens bevatten",
  invalidFromName                                                           : "Ongeldige naam, vul dan meer dan 4 karakters",
  invalidEmail                                                              : "e-mailadres ongeldig",
  emailAdd                                                                  : "Voeg e-mails toe en typ ENTER",
  userAdd                                                                   : "Voeg een gebruiker toe en tik op ENTER",
  deleteCampaignSuccess                                                     : "succesvolle verwijdering",
  campaignDeleted                                                           : "De campagne werd succesvol verwijderd",
  campaignTestSent                                                          : "Een test e-mail is succesvol verzonden",
  campaignTestSuccess                                                       : "succesvolle test",
  campaignSent                                                              : "De campagne is verzonden",
  campaignSentSuccess                                                       : "het verzenden van een succesvolle",
  campaignAdded                                                             : "De campagne is opgeslagen",
  addCampaignSuccess                                                        : "toe te voegen",
  successfulAction                                                          : "Succesvolle actie",
  operationCompleted                                                        : "Actie uitgevoerd met succes",
  errorOccured                                                              : "Er is een fout opgetreden, Gelieve te proberen later.",
  incompleteOperation                                                       : "Kan de operatie niet voltooien, onjuiste gegevens zijn ingediend",
  invalidUrl                                                                : "Kan de bewerking te voltooien, werd een ongeldige URL ingediend",
  error                                                                     : "fout",
  enterUrl                                                                  : "URL invoeren",
  search                                                                    : "Zoeken",
  deliveredTo                                                               : "Bezorgd bij",
  emailsOpen                                                                : "E-mails open",
  linkClicks                                                                : "Links klikken",
  Bounce                                                                    : "",
  Spam                                                                      : "",
  recipientsMessage                                                         : "dit filter beschouwt taal :",
  pauseCampaign                                                             : "De onderbreking van de campagne voorkomt het verzenden <br> van meer e-totdat het wordt gereactiveerd",
  pauseSending                                                              : "elke onderbreking bevordert e-mails verzenden",
  stopCampaign                                                              : "zeker stoppen met het sturen campagne",
  resume                                                                    : "overzicht",
  register_from_email                                                       : "Klik hier om via Amazon een e-mail te sturen via Amazon, klik op VALIDER voor meer informatie over het proces.",
  reply_aws_email                                                           : "Er is een email gestuurd naar Amazon, Antwoord en Vernieuwen",
  replyToError                                                              : "Vul een geldig e-mail of tekst in de indeling : naam <email@example.com>",
  validate                                                                  : "bevestigen",
  refresh                                                                   : "verversen",
  GUEST                                                                     : "GAST",
  SPEAKER                                                                   : "SPREKER",
  cardNumber                                                                : "Kaartnummer",
  refund                                                                    : "Terugbetaling",
  refundDate                                                                : "Terugbetaling's datum",
  cardHolderName                                                            : "Naam pashouder",
  cardExpirationDate                                                        : "kaart verloopdatum",
  CV                                                                        : "CVC/CVV/CID",
  rememberDetails                                                           : "onthoud deze details",
  cardType                                                                  : "kaarttype",
  CONTACT                                                                   : "",
  PARTNER                                                                   : "",
  PROSPECT                                                                  : "VOORUITZICHT",
  templateChoices                                                           : "Selecteer een sjabloon",
  "first name"                                                              : "Voornaam",
  "last name"                                                               : "achternaam",
  stopCampaignConfirm                                                       : "Wil je deze campagne zeker stoppen?",
  stop                                                                      : "HOU OP",
  Event                                                                     : "Gebeurtenis",
  "Included activities"                                                     : "Ingesloten activiteiten",
  "Excluded activities"                                                     : "Uitgesloten activiteiten",
  "Included status"                                                         : "Ingesloten status",
  "Excluded status"                                                         : "Uitgesloten status",
  Formulas                                                                  : "Formules",
  Slots                                                                     : "",
  Options                                                                   : "Opties",
  All                                                                       : "ALLE",
  templates                                                                 : "De modellen",
  NEXT                                                                      : "VOLGENDE",
  nothing_found                                                             : "Oeps, Er zijn geen resultaten gevonden voor uw zoekopdracht",
  yes                                                                       : "ja",
  no                                                                        : "neen",
  french                                                                    : "Frans",
  english                                                                   : "Engels",
  dutch                                                                     : "Nederlands",
  overview                                                                  : "overzicht",
  links                                                                     : "hyperlinks",
  approvals                                                                 : "goedkeuringen",
  approval_preferences                                                      : "Goedkeuringsvoorkeuren voor een e-mailcampagne",
  "send me"                                                                 : "stuur me",
  "send to approvers"                                                       : "stuur naar goedkeurders",
  "the approvers"                                                           : "de fiatteurs",
  "Send your campaign immediately"                                          : "Verstuur uw campagne onmiddellijk",
  "Schedule sending of your campaign for a specific time"                   : "Plan het verzenden van uw campagne voor een specifieke tijd",
  "the test is obligatory"                                                  : "de test is verplicht",
  "automatic sending"                                                       : "automatisch verzenden",
  "the minimum number of acceptance"                                        : "het minimum aantal acceptaties",
  "automatic_sending_paragraph"                                             : "staat het automatisch verzenden van de campagne toe bij het bereiken van het limietnummer zonder enige afwijzing",
  "test_obligatory_paragraph"                                               : "de campagne wordt pas verzonden nadat een test is verzonden",
  "minimum_acceptance_paragraph"                                            : "le nombre minimum de validation est requis pour l'envoi automatique",
  "no_approver_found"                                                       : "je hebt de goedkeurders nog niet gedefinieerd",
  "Add an approver"                                                         : "Geen unnambateur",
  "delivery date"                                                           : "datum en tijdstip van verzending",
  "Drag and drop some files here, or click to select files to upload."      : "Sleep enkele bestanden hier, of klik op om bestanden te selecteren om te uploaden.",
  "Attachments"                                                             : "toebehoren",
  "attachment"                                                              : "gehechtheid",
  reason                                                                    : "reden",
  "Thank you for approving this campaign"                                   : "Bedankt voor het goedkeuren van deze campagne",
  "your acceptance is taken into consideration"                             : "uw acceptatie wordt in aanmerking genomen",
  "please specify the reason for rejection"                                 : "geef de reden voor afwijzing op",
  "about_us_content"                                                        : `Tamtam.pro is een geheel van tools die een bepaalde groep toelaat om te communiceren, uitwisselen, organiseren en doeltreffend samenwerken. Het platform bevat verschillende applicaties samengevoegd naargelang de noden van de klant. Dankzij deze tools, beschikken onze klanten over de laatste technologie.`,
  "No approval request is sent for this release"                            : "Er is geen goedkeuringsverzoek verzonden voor deze release",
  "approvers' feedback for the test version"                                : "feedback van fiatteurs voor de testversie",
  "preview"                                                                 : "voorvertoning",
  "upload"                                                                  : "uploaden",
  "apply"                                                                   : "toepassen",
  "close"                                                                   : "dichtbij",
  "Once you close your changes will be lost. Do you really want to continue": "Je wijzigingen gaan verloren. Wil je echt doorgaan?",
  "search by title"                                                         : "zoeken op titel",
  "none"                                                                    : "geen",
  "last modified on"                                                        : "laatst gewijzigd op",
  "by"                                                                      : "door",
  "replicate"                                                               : "kopiëren",
  "original"                                                                : "origineel",
  "replication"                                                             : "kopiëren",
  "LEGAL_REPRESENTATIVE"                                                    : "Wettelijke vertegenwoordiger",
  'OFFICIAL': 'Officieel',
  'EXTERNAL': 'Extern',
  'MANAGER': 'Manager',
  "Apply authorization to selected users"                                   : "Toestemming toepassen op geselecteerde gebruikers",
  "Apply"                                                                   : "Toepassen",
  "Add new user"                                                            : "Voeg een nieuwe gebruiker toe",
  "creditNoteRefunded"                                                      : "Credit Note Restitutie",
  "Select All"                                                              : "Selecteer alles",
  "Deselect All"                                                            : "Tout déselectionner",
  "allow deletion"                                                          : "laat verwijdering toe",
  "allow change"                                                            : "schakel verandering in",
  "Are you sure you want to delete this template"                           : "Weet je zeker dat je deze sjabloon wilt verwijderen",
  "Allow use for all users"                                                 : "Gebruik voor alle gebruikers toestaan",
  "Allow use for certain users"                                             : "Gebruik voor sommige gebruikers toestaan",
  "user preferences"                                                        : "gebruikersvoorkeuren",
  "Add an image for this template"                                          : "Voeg een afbeelding toe voor deze sjabloon",
  "privilege"                                                               : "privilege",
  "lists"                                                                   : "lijsten",
  "create list"                                                             : "maak een lijst",
  "search by name"                                                          : "Zoeken op naam",
  "subscribers"                                                             : "abonnees",
  "mandatory list"                                                          : "verplichte lijst",
  "name"                                                                    : "naam",
  "about_payment_method"                                                    : `In dit gedeelte kunt u uw rekeningen betalen. Controleer een van de volgende methoden en voer de weergegeven informatie in.`,
  "choice_payment_mode"                                                     : "kies een betaalmethode",
  "bank_transfer"                                                           : "overdracht",
  "payOnLine"                                                               : "Online betalen",
  "payTransfer"                                                             : "Betalen per overschrijving",
  "paymentUpdated"                                                          : "Betaling bijgewerkt",
  "transferBank-about"                                                      : "Zodra uw bestelling is geplaatst, kunt u betalen via overschrijving.",
  "transferBank-about-2"                                                    : "U vindt de nodige informatie hierboven: IBAN, BIC en VCS (voor de gestructureerde communicatie).",
  "transferBank-about-3"                                                    : "Houd er rekening mee dat een overboeking minimaal 48 uur nodig heeft voordat het geld van de ene rekening naar de andere wordt overgemaakt. Na ontvangst van uw betaling wordt uw bestelling gevalideerd en wordt er een factuur naar u verzonden naar het e-mailadres:",
  "hello"                                                                   : "Hallo",
  "badge1"                                                                  : "kies een betaalmethode uit de drie modi.",
  "badge2"                                                                  : "afhankelijk van de gekozen betaalmethode, hebt u een formulier om in te vullen.",
  "badge3"                                                                  : "je kunt je pakket veranderen.",
  "adyen1"                                                                  : "Dankzij Adyen beschikt u over een internationaal bereik via een enkel systeem.",
  "adyen2"                                                                  : "Adyen is een flexibele, wereldwijde en volledig compliante betaaloplossing voor marktplaatsen.",
  "virement1"                                                               : "Dit is een betaalmethode die niet online is",
  "virement2"                                                               : "In dit geval gaat u naar de dichtstbijzijnde bank om ons het bedrag te betalen volgens uw bestelling op de rekening waarvan de RIB hieronder is aangegeven",
  "onlinePaymentDesc"                                                       : "Met onze oplossing kunt u betalen met Discover Card, American Express, Maestro, Diners Club, Master Card of Visa.",
  "badgeAdmin1"                                                             : "Je moet het coda-bestand downloaden dat door de bank is verzonden.",
  "badgeAdmin2"                                                             : "kies een coda-bestand dat u al in de ruimte hebt geïmporteerd.",
  "badgeAdmin3"                                                             : "klik op de knop Betalingen maken om de betalingen te maken die aan dit coda-bestand zijn gekoppeld en om betalingen met bestellingen te matchen.",
  "titreUser"                                                               : "Lijst met gebruikers",
  "listeTransfers"                                                          : "Lijst met overschrijvingen",
  "listeOrders"                                                             : "Lijst met bestellingen",
  "dropzoneText"                                                            : "Een of meer coda-bestanden slepen en neerzetten",
  "titreResult"                                                             : "lijst met geïmporteerde transfers",
  "authorizePayment"                                                        : "Betaalmethodes",
  "prevatAmount"                                                            : "Bedrag excl. btw",
  "coponCode"                                                               : "Coupon code",
  "refClient"                                                               : "klantreferentie",
  "amount"                                                                  : "Bedrag",
  "bankRef"                                                                 : "Bankreferentie",
  "operationCode"                                                           : "Operatie Code",
  "extrait"                                                                 : "Extract",
  "numOperation"                                                            : "Bewerkingsnummer",
  "phone"                                                                   : "Phone",
  "createPayment"                                                           : "maak een betaling",
  "reconsillation-coda"                                                     : "verzoening Coda",
  "orders"                                                                  : "COMMANDOS",
  "choice"                                                                  : "kiezen",
  "associate"                                                               : "associëren",
  "associated-status"                                                       : "Statusassociatie",
  "acheteur"                                                                : "koper",
  "warning-association-button"                                              : "controleer beide zijden",
  "warning-importation-button"                                              : "je moet minstens één Coda-bestand kiezen",
  "customers"                                                               : "GEBRUIKERS",
  "transfers"                                                               : "BANK-TRANSFERS",
  "mapCoda"                                                                 : "VERZOENING",
  "codaImport"                                                              : "INVOER VAN CODA",
  "payment-app"                                                             : "Toepassing",
  "admin-espace"                                                            : "ADMINISTRATOR RUIMTE",
  "settings"                                                                : "Instellingen",
  "transfer"                                                                : "Overdracht",
  "credit_note_refunded"                                                    : "Dit tegoed is al terugbetaald in dit account : ",
  "credit_note_refunded1"                                                   : "Raadpleeg alstublieft een andere creditnota",
  "iban_credit_note"                                                        : "Voer uw Iban in, zodat we u op uw account kunnen terugbetalen",
  "saveIban"                                                                : "Uw Iban is succesvol geregistreerd",
  "not_user"                                                                : "u bent niet de gebruiker van deze creditnota",
  "iban_invalid"                                                            : "Iban is niet geldig",
  "bic_invalid"                                                            : "Bic is niet geldig",
  "import_coda_1"                                                           : "Codas die al zijn geïmporteerd",
  "warning_search_mapping"                                                  : "U moet een overdracht controleren",
  "warning_search_bankTransfer"                                             : "U moet een bestelling controleren",
  "ignor"                                                                   : "Negeren",
  "force-association"                                                       : "De associatie dwingen",
  "NOT_REFUNDED"                                                            : "Niet Terugbetaald",
  "REFUNDED"                                                                : "Terugbetaald",
  "BANK_TRANSFER"                                                           : "overschrijving",
  "OGONE"                                                                   : "Ogone",
  "PAYPAL"                                                                  : "Paypal",
  "MANGO_PAY"                                                               : 'Mango Pay',
  "MANUAL"                                                                  : "handboek",
  "NOT_MAPPED"                                                              : "onbekend",
  "ATTRIBUTED"                                                              : "associëren",
  "ASSOCIATED"                                                              : "associëren",
  "NOT_ASSOCIATED"                                                          : "niet verbonden",
  "sucess-file"                                                             : "Codas-bestanden met succes verwerkt",
  "operation"                                                               : "operatie",
  "related-operations"                                                      : "gerelateerde operaties",
  "attribute"                                                               : "onderscheiding",
  "manual-payment"                                                          : "Betalingsverschil (betalingshandleiding)",
  "credit-note-number"                                                      : "Nummer ",
  "credit-note-organization"                                                : "Organisatie :",
  "credit-note-date"                                                        : "Maak de  :",
  "credit-note-apply"                                                       : "toepassen",
  "show-invoice"                                                            : "download de factuur in pdf",
  "invalid-coda-files"                                                      : "Ongeldige Coda-bestanden",
  "no-data-filter-left"                                                     : "Geen resultaten voor",
  "no-data-filter-right"                                                    : "met het huidige filter.",
  "delete-filter"                                                           : "Verwijder dit filter",
  "PAID"                                                                    : "Betaald",
  "OVER_PAID"                                                               : "Te veel betaald",
  "UNDER_PAID"                                                              : "Onder betaald",
  "NOT_PAID"                                                                : "Niet betaald",
  "ORDER"                                                                   : "Bestellingen",
  "INVOICE"                                                                 : "Factuur",
  "CREDIT_NOTE"                                                             : "Creditnota's",
  "Date"                                                                    :"Datum",
  "user-email"                                                              :"Gebruikers e-mail",
  "To"                                                                      :"Naar",
  "Application"                                                             : "Toepassing",
  "document-number"                                                         :"Aantal geselecteerde documenten is: ",
  "document-total"                                                          : "Totaal aantal documenten is : ",
  "document-total-selected"                                                 : "  Totaal aantal geselecteerde documenten is : ",
  "Import Coda files"                                                       :"IMPORTEER CODA-BESTANDEN",
  "Pending"                                                                 : 'In afwachting',
  "Documents"                                                               : "Documenten",
  "Assignments"                                                             : "Opdrachten",
  "PAYMENT_DIFFERENCE"                                                      : "Betalingsverschil",
  "EXCHANGE_DIFFERENCE"                                                     : "Valutaverschil",
  "CACHE_PAYMENT"                                                           : "Contante betaling",
  "TOO_MUCH_PAID"                                                           : "Te veel betaald",
  "PAYMENT_OTHER_ACCOUNT"                                                   : "Betaling ander account",
  "required-value"                                                          : "Dit veld is verplicht",
  "show-order"                                                              : "download de bestelling in pdf",
  "order-detail"                                                            : "Detail van de bestelling",
  "show"                                                                    : "Tonen",
  "uen"                                                                     : "BTW-nummer",
  "get-pdf"                                                                 :"Download de pdf",
  "get-efff"                                                                 :"Download de EFFF",
  "send-by-mail"                                                            :"Per post versturen",
  "redo-pdf"                                                                :"Regenereer de pdf",
  "client-data"                                                             :"Klant gegevens",
  "not-order-user"                                                          : "U bent niet de gebruiker van deze bestelling",
  "Sous-Type"                                                               :"Sub Type",
  'Vous avez importé XXXX fichiers coda'                                    : 'U hebt XXXX-codabestanden geïmporteerd',
  'paiements non réconciliés'                                               : 'niet-afgestemde betalingen',
  'paiements réconciliés'                                                   : 'afgestemde betalingen',
  'paiements ignorés'                                                       : 'genegeerde betalingen',
  'pour'                                                                    : 'voor',
  "show-stats"                                                              :"Statistieken weergeven",
  "stats"                                                                   : "statistiek",
  "EN QUELQUES CHIFFRES"                                                    : "IN EEN PAAR CIJFERS",
  "Facturation"                                                             : "Billing",
  "CA"                                                                      : "Omzet",
  "payment-ogone"                                                           : "Raadpleeg de data en facturen betaald door Ogone",
  "payment-virement"                                                        : "Raadpleeg de data en facturen betaald via overschrijving",
  "invoices-not-paid"                                                       : "Onbetaalde facturen",
  "facture-a-payer"                                                         : "Facturen om te betalen",
  'Nothing to show'                                                         : 'Niets om te laten zien',
  "Notifications of updates"                                                : "Meldingen van updates",
  "Invoices"                                                                : "Facturen",
  "manual-amount"                                                           : "Handmatig bedrag",
  "manual-comment"                                                          : "Handmatige opmerking",
  "user-phone"                                                              : "Telefoonnummer",
  "VALID"                                                                   : "Actief",
  "CANCELED"                                                                : "geannuleerd",
  "to-be-refunded"                                                          : "Terug te betalen",
  "MONTH"                                                                   : "Maand",
  "CHOOSE-EVENEMENT"                                                        : "Kies een evenement",
  'Users': 'Gebruikers',
  'User'                                                                   : 'Gebruiker',
  'Organization roles': 'Organisatierollen',
  'Payment roles': 'betalingsrol',
  'roles': 'rollen',
  "ORDERS"                                                                  : "bestellingen",
  "INVOICES"                                                                  : "facturen",
  "CREDIT-NOTES"                                                                  : "creditnota's",
  "ACCOUNTANT" : "ACCOUNTANT",
  "ASSISTANT" : "ASSISTENT",
  "AUCUN" : "GEEN",
  'New user': 'Nieuwe gebruiker',
  'success-save-iban-bic' : "Gegevens zijn succesvol opgeslagen",
  'assistant-title' : "« Deze gegevens kunnen alleen worden gewijzigd door de beheerder »",
  'configure-data' : "Configuratie van organisatiegegevens",
  'import-coda-test': "testcodabestand genereren",
  'Import Coda Testing' : "Coda-test  genereren",
  'and': "en",
  'other user(s)' : 'andere gebruiker (s)',
  'all_event' : "Alle evenementen",
  'other_year' : "andere jaar (jaren)",
  'other_event' : "andere evenementen",
  'unabledCommunity': "Je hebt geen toegang om door te gaan met deze community!",
  "none-event" : "Geen evenementen",
  "payer-mongo-pay" : "Betaal met Mongo Pay",
  "Payer-sans-enregistrer-la-carte" : "Betaal met een andere kaart",
  "Payer-avec-cette-carte" : "Betaal met deze kaart",
  "Enregistrer-et-payer-avec-une-autre-carte" : "Registreer mijn kaart",
  "ou" : "OF",
  "card-Number" : "Kaartnummer",
  "expiration-Date" : "Vervaldatum",
  "cardNumber_invalid" : "Kaartnummer is ongeldig",
  "date dexpiration_invalid" : "Vervaldatum is ongeldig",
  "cvv_invalid" : "CVV is ongeldig",
  "visualiser-document" : "Bekijk het document",
  "visualiser-vos-document" : "Bekijk uw documenten",
  "visualiser-vos-paiement" : "Bekijk betalingen",
  "reconcilier-paiement" : "Verzoen betaling",
  "payment-ok" : "De betaling is gelukt",
  "Montant-payer" : "Het te betalen bedrag : ",
  "credit-card" : "Kredietkaart",
  "debit-card" : "Debetkaart",
  "pay": "Betalen\n",
  "choice-methode-paiement" : "Kies je betaalmethode",
  "Payer-ici" : "Betaal hier :",
  "cgu" : "Servicevoorwaarden",
  "order-post-traitment" : "Deze bestelling is het onderwerp van een mislukt afstemmingsproces.",
  "data-organization" : "Organisatiegegevens",
  "gestion-rappel" : "Beheer van herinneringen",
  "interval": "Bepaal het tijdsinterval voor herinneringen voor elke toepassing.",
  "modify-emailing-all-application": "Sjablonen aanpassen voor alle applicaties",
  "modify-emailing--application" : "Sjablonen aanpassen",
  "event-list" : "Lijst met aankomende evenementen",
  "events" : "Opleidingen / cycli / pakket",
  "default-config" : "Standaard configuratie",
  "send-last-rappel" : "Stuur de laatste callback",
  "send-rappel" : "Stuur callback",
  "re-send-rappel" : "re-send callback",
  "show-ebox-admin" : "Bekijk uw E-box",
  "progress-bar-documents" : "Betaalde documenten : ",
  "progress-bar-documents-credit-notes" : "Terugbetaalde creditnota's : ",
  "progress-bar-rappels" : "Verzonden Herinneringen : ",
  "sended": "Verzonden",
  "sende": "Heeft verzonden",
  "innaproprie": "Ongepast",
  "edit-campagne" : "Campagne bewerken",
  "send-campagne" : "Verstuur campagne",
  "send-campagne-relance" : "Stuur een campagne met herinneringen",
  "years" : "Jaren",
  "add-year" : "Voeg een jaar toe",
  "apps" : "De applicaties",
  "add-app" : "Voeg een applicatie toe",
  "add-event" : "Voeg een evenement / cyclus / pakket toe",
  'registering' : "opleiding",
  'cycle_registering' : "Cyclus",
  'packOrder' : "pack",
  "inscription-type" : "Type registratie",
  "add-inscription" : " Voeg een Type registratie",
  "send-second-rappel" : "Verzend de volgende callback",
  "qr-expiration" : "De Pay Coniq QR-code is verlopen in :",
  "payment-mango-pay": "Raadpleeg de data en facturen betaald door Mango Pay",
  "payment-pay-coniq": "Raadpleeg de data en facturen betaald door Pay Coniq",
  "BANK_TRANSFER_MANGO_PAY" : "MangoPay-overboeking",
  "BANK_TRANSFER_PAYCONIQ" : "Payconiq-overboeking",
  "PAY_CONIQ"                                                               : 'Payconiq',
  "DOWNLOAD_ORDER": "download de bestelling",
  "NEW_BANK_CARD": "Nieuwe bankkaart",
  "YES_DELETE": "Ja, verwijderen",
  "CONFIRM_DELETE_CARD": "Weet u zeker dat u deze bankkaart wilt verwijderen?",
  "BANK_DETAILS": "bankgegevens",
  "TITLE": "titel",
  "PAID_REGISTRANTS": "Betaalde registranten",
  "FREE_REGISTRANTS": "Gratis registranten",
  "TOTAL": "Totaal",
  "DETAILS": "Details",
  "PAYOUT_RATE": "Uitbetalingspercentage",
  "Order": "Bestelling",
  "AVERAGE_PRICE": "Gemiddelde prijs per aankoop",
  "REGISTRATION": "inschrijving",
  "TYPE": "Type",
  "FORMAT": "Formaat",
  "REGISTRATIONS": "registraties",
  "from_time": "van",
  "to_time": "tot",
  "DISPLAY_TRAININGS": "De trainingen van de cyclus weergeven",
  "CYCLE_TRAINING": "Fietstraining : ",
  "REDUCE_CYCLE": "Verminder fietstraining",
  "GLOBAL": "Globaal",
  "ACTIVITIES": "Activiteiten",
  "REGISTERED": "Geregistreerd",
  "PAYING": "Betalen",
  "FREE": "Vrij",
  "PAGE_NOT_FOUND": "Pagina niet gevonden",
  "PAYMENT_REFUSED_MESSAGE": "Het spijt ons dat we niet positief kunnen reageren op uw betalingsverzoek.",
  "RETRY_PAYMENT": "probeer de betaling opnieuw",
  "GENERAL": "Algemeen",
  "DATE_CREATION": "Aanmaakdatum",
  "COMPLETE_FIELDS": "Vul alstublieft alle velden in",
  "COMMAND_LINES": "Opdrachtregels",
  "REFUND_PAGE_HEADER": "Mijn terugbetalingsgegevens wijzigen",
  "BANK": "Bank",
  "ATTRIBUTE_WITH_VCS": "Toewijzen via VCS",
  "ATTRIBUTE_WITH_VCS_MESSAGE": "Wilt u deze overdracht via vcs toewijzen?",
  "REFUND_DONE": "De terugbetaling is al gedaan.",
  "VIEW_REFUND_DETAILS": "Bekijk vergoedingsgegevens",
  "CA_FROM_CYCLES": "Inkomsten gegenereerd uit cycli",
  "MODEL_RELANCE": "Stimuleringsmodellen",
  "MANAGEMENT_REMINDERS": "Beheer van herinneringen",
  "REMINDER_SUBTITLE": "Bepaal het herstarttijdsinterval voor elke toepassing.",
  "ORGANIZATION_DATA": "Organisatiegegevens",
  "VIREMENT": "Overschrijvingen",
  "RETOUR": "Opbrengst",
  "EMAIL_CONFIGURATION": "E-mails configureren",
  "MODEL_RAPPEL": "Herinneringssjablonen",
  "SELECT_ALL": "Selecteer alles",
  "DESELECT_ALL": "Deselecteer alles",
  "PERSONS": "Mensen",
  "first-payment" : "Eerste betaling",
  "date-first-payment" : "Datum van 1e betaling",
  "second-payment" : "Tweede betaling",
  "date-second-payment" : "Datum van 2e betaling",
  "payment-account" : "Betaalrekening",
  "double-payment" : "Dubbel betaalde bestellingen",
  "MANGO_REFUND_CONFIRM_TITLE" : "Wil je echt een terugbetaling doen met Mango pay?",
  "REFUND_WITH_MANGO_PAY" : "Terugbetaling met Mango Pay",
  "ADMINISTRATION": "Administratie",
  "FEES_CONFIGURATION": "Commissie instellen",
  "CREDIT_CARD_CONFIGURATION": "Creditcards instellen",
  "DEBIT_CARD_CONFIGURATION": "Debetkaarten configureren",
  "FEES_SECTION_SUBTITLE": "Vaste en variabele commissies bepalen voor elke organisatie",
  "FIX_FEE": "Vaste vergoeding",
  "VARIABLE_FEE": "variabele commissie",
  "MANGO_FEES": "Mango Pay-kosten",
  "MANGOPAY_CONFIGURATION": "Mangopay-configuratie :",
  "PAYCONIQ_CONFIGURATION": "Payconiq-configuratie :",
  "TRANSFERS_CONFIGURATION": "Configuratie van overdrachten :",
  "SEND_DOCUMENT_ONLINE": "Verstuur het document via e-mail",
  "ARTICLE_CODE": "artikelcode",
  "REFUND_DATE_MANDATORY": "De terugbetalingsdatum is verplicht",
  "REFUND_TYPE_MANDATORY": "Het soort vergoeding dat nodig is",
  "REFUND_JUSTIFICATION_MANDATORY": "Bewijs van terugbetaling is vereist",
  "REGISTRATION_CANCELED": "Registratie geannuleerd",
  "REFUND_TYPE_PLACEHOLDER": "Type vergoeding",
  "REFUND_JUSTIFICATION_PLACEHOLDER": "Reden voor terugbetaling",
  "clientName"                                                               : "Naam van de klant",
  "Prix/Base" : "Prijs/Basis",
  "choice-client" : "Kies een klant",
  "commission-sum" : "Som van commissies : ",
  "ACTION_CONFIGURATION": "Actie configuratie",
  "ACTION_CONFIGURATION_SAVED": "De configuratie is opgeslagen",
  "ACTIONS": "Acties",
  "ACTION": "Actie",
  "EMAIL_TYPE": "E-mailtype",
  "HOURS_NUMBER": "Aantal uren",
  "ACTION_CONFIGURATION_ERROR": "Selecteer waarden voor alle velden",
  "WAITING_INTERVAL": "Wachtinterval",
  "ACTION_DATE": "Actie datum",
  "EVENT_CYCLE": "Evenement/Cyclus",
  "RAPPEL": "Terugroepen",
  "SELECT_REFUNDED_ORDERS" : "Selecteer de bestellingen die u via bankoverschrijving heeft terugbetaald:",
  "CONFIRMATION_MESSAGE" : "Wil je deze actie echt doen?",
  "REFUNDED_WITH_BANK_TRANSFER" : "Terugbetaald via overschrijving",
  "FEES_PER_TRANSACTION" : "Commissie per transactie",
  "AMOUNT_PER_TRANSACTION" : "Transactiebedrag",
  "refund-payment" : "terugbetaling",
  "creditor" : "operator",
  "payment" : "Betaling",
  "detail-payment-refund" : "Details van betalingen en terugbetalingen",
  "ORDER_LINES": "Orderregels",
  "INVOICE_LINES": "Factuurregels",
  "CREDIT_NOTE_LINES": "Kredietnotaregels",
  "ACTIVATED" : "Ingeschakeld",
  "DEACTIVATED" : "Gehandicapt",
  'CREDIT_NOTE_PARTIAL' : 'Gedeeltelijke creditnota',
  'CREDIT_NOTE_CONFIRM_TITLE' : 'Weet u zeker dat u een creditnota voor deze factuur wilt aanmaken?',
  'CREDIT_NOTE_CREATED_MESSAGE' : 'Er is al een creditnota aangemaakt voor deze factuur',
  'PARTIAL_CREDIT_NOTE_CREATED_MESSAGE' : 'Voor deze factuur is al een gedeeltelijke creditnota aangemaakt met een bedrag van ',
  'PARTIAL_CREDIT_NOTE_CREATED_PLURAL_MESSAGE' : 'Voor deze factuur zijn al gedeeltelijke creditnota\'s aangemaakt met een bedrag van ',
  'FEED_MANGO_WALLET' : 'Uw portemonnee opladen',
  'ENTER_AMOUNT_FOR_MANGO_WALLET' : 'Voer het bedrag in waarmee u uw portefeuille wilt financieren : ',
  'MANGO_WALLET_BALANCE' : 'Uw saldo is : ',
  'USE_THIS_CARD' : 'Deze kaart gebruiken',
  'FEED_MANGO_WALLET_QUESTION' : 'Wil je je portemonnee voeden?',
  'REFUND_SUCCEEDED' : 'De terugbetaling is succesvol afgerond',
  'REFUND_FAILED' : 'De terugbetaling is mislukt wegens gebrek aan evenwicht.',
  'CREATE_PARTIAL_CREDIT_NOTE_SUM_ERROR' : 'De som van de bedragen van de creditnota\'s overschrijdt het totale factuurbedrag',
  'PAYOUT_SUM_ERROR' : 'Het bedrag is groter dan wat u op uw portemonnee heeft',
  'ENTER_PAYOUT_AMOUNT_FOR_MANGO' : 'Voer het bedrag in dat u wilt overboeken naar uw bankrekening',
  'payout' : 'Een uitbetaling doen',
  'CREATE_CREDIT_NOTE' : 'Een creditnota aanmaken',
  'PRODUCT_GROUP' : 'Productgroep',
  'ADD_LINE' : 'Een regel toevoegen',
  'EXCLUDING_VAT_TOTAL' : 'Totaal excl. btw',
  'INCLUDING_VAT_TOTAL' : 'Totaal incl. btw',
  'CREDIT_NOTE_AMOUNT_ERROR' : 'Het totale bedrag van de creditnota mag niet hoger zijn dan het bedrag van de factuur.',
  'CANCEL_REGISTRATION_1' : 'Annuleer de registratie van ',
  'CANCEL_REGISTRATION_2' : ' gekoppeld aan deze factuur',
  'not_refund_credit_note' : 'Niet terugbetaalde creditnota\'s',
  'dashboard' : 'Dashboard-tools',
  'import-coda-via-email' : 'Coda importeren via e-mail',
  'user-name-invalid' : 'Ongeldig e-mailadres',
  'password-invalid' : 'Wachtwoord is vereist',
  'password' : 'Wachtwoord',
  'mail-box-invalid' : 'imap-server is vereist',
  'test-connection' : 'Testverbinding',
  'configure-imap' : 'De IMAP-verbinding configureren',
  'connection-success' : "De verbinding is tot stand gebracht",
  'config-imap' : "Imap configureren",
  'server-imap' : "Server imap",
  'from-email' : "Importeer alleen coda's die afkomstig zijn van:",
  'user-name' : "Bron e-mail",
  'port-invalid' : 'Poort is vereist',
  'REGISTRATIONS_TOTAL_NUMBER' : "Totaal aantal registraties",
  "TRAININGS" : "opleidingen",
  "CYCLES" : "cycli",
  "SEASONS" : "seizoenen",
  "CONGRESS" : "congres",
  "CYCLES_ESSENTIAL" : "essentiële cycli",
  "DAILY" : "Dagelijks",
  "WEEKLY" : "Wekelijks",
  "MONTHLY" : "Maandelijks",
  "YEARLY" : "Jaarlijks",
  "RETRY" : "Probeer het opnieuw",
  "ERROR_OCCURED" : "Er is een fout opgetreden. Probeer het nog eens.",
  "Jan" : "Jan",
  "Fév" : "Feb",
  "Mar" : "Maa",
  "Avr" : "Apr",
  "Mai" : "Mei",
  "Jui" : "Jun",
  "Jul" : "Jul",
  "Aoû" : "Aug",
  "Sep" : "Sep",
  "Oct" : "Okt",
  "Nov" : "Nov",
  "Déc" : "Dec",
  "NO_REGISTRATIONS" : "Er zijn geen gegevens in de geselecteerde periode.",
  'HTVA' : 'excl. btw',
  'TVAC' : 'incl. btw',
  'TVA' : 'btw',
  'FACTURATIONS' : 'Facturaties',
  'INDIVIDUAL_FORMULAS' : 'Individuele pakketten',
  'COMPANY_PACKS' : 'Bedrijfspakken',
  "GUESTS": "Gasten",
  "PAID_FREE_PACK_REGISTRANTS": "Betaalde abonnees + Gratis abonnees + Abonnees via pakketten",
  "LAST_CACHE_UPDATE": "Laatste bijwerking van gegevens : ",
  "NOW": "nu",
  "DOWNLOAD_DOCUMENTS_IN_XML_FORMAT": "Documenten downloaden in xml-formaat",
  "SUBSCRIPTIONS_PAGE_TITLE": "Abonnementen",
  "SUBSCRIPTIONS_PAGE_SUBTITLE": "Beheer uw abonnementen",
  "SUBSCRIPTION_CANCELLED": "Onderbroken",
  "SUBSCRIPTION_STOPPED": "Gestopt",
  "SUBSCRIPTION_FAILED": "Mislukt",
  "FREQUENCY": "Frequentie",
  "SUBSCRIPTION_LAST_PAYMENT": "Laatste betaling",
  "NO_SUBSCRIPTION_FOUND": "U hebt geen abonnement",
  "SUBSCRIPTION_NEXT_DEBIT_INFO": "De volgende automatische incasso is op ",
  "SUBSCRIPTION_FAILED_DEBIT_INFO": "Automatische incasso mislukt, zie de abonnementsgeschiedenis om het probleem op te lossen",
  "SUBSCRIPTION_ENDED_INFO": "Uw abonnement is geannuleerd. (mislukte automatische incasso)",
  "SUBSCRIPTION_CANCELLED_INFO": "Je abonnement is opgeschort. Daar komt eigenlijk een einde aan ",
  "SUBSCRIPTION": "Abonnement",
  "CHANGE_MY_CARD": "Verander mijn kaart",
  "CANCEL_SUBSCRIPTION": "Mijn abonnement opzeggen",
  "BILLING_DATA": "Factureringsgegevens",
  "CANCEL_SUBSCRIPTION_TITLE": "Wijzig de kaart die aan het abonnement is gekoppeld",
  "CANCEL_SUBSCRIPTION_CONFIRMATION": "Wil je echt je abonnement opzeggen?",
  "CARD_USED_FOR_SUBSCRIPTION": "De kaart die in verband met dit abonnement wordt gebruikt, is ",
  "SUBSCRIPTION_CHANGE_CARD_INFO_1": "Om de nieuwe kaart te controleren, zal u ",
  "SUBSCRIPTION_CHANGE_CARD_INFO_2": "Een terugbetaling zal achteraf plaatsvinden.",
  "NEW_CARD": "Nieuwe bankkaart",
  "DOWNLOAD_INVOICE": "De factuur downloaden",
  "DOWNLOAD_CREDIT_NOTE": "De kredietnota downloaden",
  "SUBSCRIPTION_CANCELLED_LOG": "U heeft uw abonnement opgezegd",
  "CIT_SUCCEEDED": "Initialisatie betaling succesvol uitgevoerd",
  "MIT_SUCCEEDED": "Succesvolle bemonstering",
  "MIT_FAILED": "Bemonstering mislukt",
  "MIT_FAILED_AUTHENTICATION_NEEDED": "Automatische incasso mislukt: 3DS-verificatieverzoek door de bank",
  "MIT_FAILED_INACTIVE_CARD": "Collectie mislukt: Kaart inactief",
  "MID_CIT_SUCCEEDED": "Betaling succesvol uitgevoerd",
  "MID_CIT_FAILED": "Betaling mislukt",
  "CARD_CHANGED": "De kaart die aan uw abonnement is gekoppeld, is gewijzigd",
  "PAYMENT_FAILED": "Niet betaald ",
  "CARD_ACTIVATED": "Actieve kaart: betaling van ",
  "MID_CIT_REFUND_SUCCEEDED": "De terugbetaling van het activeringsbedrag van de kaart gebeurt met succes",
  "MID_CIT_REFUND_FAILED": "Terugbetaling van het activeringsbedrag van de kaart mislukt",
  "SUCCESS": "Succes",
  "SUBSCRIPTION_HISTORY": "Abonnementsgeschiedenis :",
  "CARD_IN_USE": "In gebruik",
  "SUBSCRIPTIONS_SUPPORTED_CARDS_INFO": "Terugkerende kaartbetalingen zijn alleen beschikbaar met CB/Visa/Mastercard. De volgende kaarten worden niet ondersteund: Amex, Maestro, en BCMC.",
  "YES_CANCEL": "Ja, annuleren",
  "FREE_TRIAL_STARTED": "Begin van uw gratis proefperiode",
  "FREE_TRIAL": "Gratis proef",
  "FREE_TRIAL_MONTH": " tijdens uw eerste 30 dagen.",
  "WE_SEND": "Wij sturen u ",
  "BILLING_EMAIL": "een facturatie e-mail voor elke gedane inzameling.",
  "NEXT_DEBIT": "Volgende maandelijkse betaling is verschuldigd op ",
  "WITHOUT_COMMITMENT": "Zonder verplichting.",
  "SUBSCRIPTION_CAN_BE_CANCELLED": " Het abonnement kan te allen tijde online worden opgezegd.",
  "DEFINE_CARD": "Definieer uw betaalkaart:",
  "ftp_config" : "FTP-configuratie",
  "DOWNLOAD_DOCUMENTS_FTP" : "Documenten exporteren naar FTP-server",
  "user_name" : "Gebruikersnaam",
  "host_name" : "HostNaam",
  "protocol" : "Protocol",
  "new_client" : "Nieuwe klant",
  "client_state" : "Cliëntstatus",
  "last_invoice" : "Laatste factuur",
  "OFFER_WITHOUT_INVOICE": "Aanbieding (zonder factuur)",
  "FORCE_WITH_INVOICE": "Forceren (met factuur)",
  "REGISTRATION_WAS_OFFERED": "De registratie was geforceerd. (aangeboden)",
  "REGISTRATION_WAS_FORCED": "Registratie was gedwongen. (in afwachting van betaling)",
  "FORCE_REGISTRATION": "Registratie afdwingen",
  "TEL": "Tel.",
  "reminder_sent" : "Stuur geen herinneringen",
  "PREVIOUS_INVOICE" : "Vorige factuur",
  "FILES_SUCCESSFULLY_IMPORTED": "De bestanden zijn succesvol geïmporteerd",
  "CONFIGURE_MODELS": "Modellen configureren",
  "IMPORT": "Import",
  "IMPORT_CODAS_VIA_DROPBOX": "Codas importeren via Dropbox",
  "CONFIGURE_DROPBOX": "Dropbox configureren",
  "CONNECT_TO_DROPBOX": "Verbinden met Dropbox",
  "FOLDER_NOT_FOUND": "Bestand niet gevonden",
  "DROPBOX_FOLDER": "Dropbox-map",
  "invalid-uen": "Het btw-nummer is ongeldig",
  "IMPORT_NOW": "Nu importeren",
  "CODA_IMPORT_COMMAND_STARTED": "Het importcommando van de codas-bestanden is gestart. De contactpersoon van de organisatie ontvangt een e-mail zodra de invoer is voltooid.",
  "CONFIGURED_FOLDER": "De geconfigureerde map is : ",
  "DROPBOX_FOLDER_NOT_CONFIGURED": "De Dropbox-map is niet geconfigureerd.",
  "SUBSCRIPTION_UPGRADED": "U heeft uw abonnementsformule gewijzigd",
  "CHOOSE_WALLET_FEEDING_MODE": "Kies de voedingsmodus van uw wallet",
  "SEE_BANK_TRANSFERS": "Bankoverschrijvingen bekijken",
  "BANK_CARD": "Bankkaart",
  "ENTER_TAG": "Voer een tag in om de bankoverschrijving te identificeren",
  "PAYMENT_CREATED": "De betaling is aangemaakt maar nog niet goedgekeurd en verwerkt.",
  "PLEASE_MAKE_TRANSFER": "Maak een overdracht van {amount} en controleer later.",
  "WIRE_REFERENCE": "Referentie van bankoverschrijving",
  "ADDRESS": "Adres",
  "CITY": "Stad",
  "COUNTRY": "Land",
  "CREATED_BANKWIRES": "De aangemaakte bankoverschrijvingen",
  "VIEW_SUBSCRIPTION": "Bekijk abonnement",
  "dropbox_count_down" : "De volgende automatische import is in :",
  "missing_coda_info" : "Let op, er ontbreken Codas-bestanden, raadpleeg dit voor meer details ",
  "link" : "link",
  "previous_date" : "Datum van het vorige Coda-bestand",
  "next_date" : "Datum van het volgende Coda-bestand",
  "account" : "Organisatieaccount",
  "missing_coda_list" : "Lijst met ontbrekende coda-bestanden",
  "balance" : "Het saldo van de datum  : ",
  "is" : " Oosten : ",
  "autorize_balance" : "Saldoweergave toestaan",
  "balance_privilege" : "Saldorechten",
  "total_balance" : "Het totale saldo ",
  "LAST_REMINDER": "Laatste herinnering",
  "DOCUMENTS": "De documenten",
  "CAMPAIGNS": "De campagnes",
  "NUMBER" : "Nummer",
  "JANUARY": "januari",
  "FEBRUARY": "februari",
  "MARCH": "maart",
  "APRIL": "april",
  "MAY": "mei",
  "JUNE": "juni",
  "JULY": "juli",
  "AUGUST": "augustus",
  "SEPTEMBER": "september",
  "OCTOBER": "oktober",
  "NOVEMBER": "november",
  "DECEMBER": "december",
  "START_MONTH": "Start Maand:",
  "END_MONTH": "Eind Maand:",
  "COMPARE_WITH_ANOTHER_YEAR": "Vergelijken met een ander jaar",
  "REDUCE": "Verminderen",
  "CA_TOTAL_NUMBER" : "Totaalbedrag van de behaalde excl. btw",
  "REGISTRATIONS_COMPARE_STATS": "Vergelijking van het totale aantal registraties",
  "CA_COMPARE_STATS": "Vergelijking van de totale omzet excl. BTW",
  "MANAGE_MY_TURNOVER" : "Mijn omzet beheren",
  "ALL" : "ALLE",
  "ANNUAL_TARGET" : "Jaarlijkse doelstelling",
  "ANNUAL_TARGET_TEXT" : "Stel meetbare en haalbare doelen om ervoor te zorgen dat u op schema ligt.",
  "REGISTRANTS_TOTAL_NUMBER" : "Totaal aantal betalende inschrijvers",
  "PRICE_PER_UNIT" : "Prijs per eenheid",
  "TOTAL_BUDGET" : "Totale begroting",
  "COMPARE_TO_PREVIOUS_YEAR" : "dan het voorgaande jaar",
  "COMPARE_PLUS" : "bovendien",
  "COMPARE_MINUS" : "minder",
  "CURRENT_BUDGET_RESULT" : "Huidig begrotingsresultaat ",
  "TOTAL_REALIZED" : "Totaal bereikt",
  "ANNUAL_ADJUSTMENT_RESULT" : "Resultaat van de jaarlijkse aanpassing",
  "TOTAL_ADJUSTMENT" : "Totale aanpassing",
  "FROM" : "van",
  "TO" : "tot",
  "COMPARISON_CA_TB" : "Vergelijking van de gerealiseerde omzet met het streefbudget",
  "COMPARISON_ADJUSTMENT_TB" : "Vergelijking van de jaarlijkse aanpassing met de doelbegroting",
  "FOLLOW_UP" : "Follow-Up",
  "NO_ANALYSIS" : "Er is geen analyse gemaakt",
  "FOLLOW_UP_TXT1" : "Neem de tijd om uw doelbudget voor {year} zorgvuldig te configureren voordat u een follow-up genereert.",
  "FOLLOW_UP_TXT2" : "Let op! De begroting voor {year} kan na het genereren van de follow-up niet meer worden gewijzigd.",
  "GENERATE_FOLLOW_UP" : "DE FOLLOW-UP GENEREREN",
  "TARGET_BUDGET" : "doelbudget",
  "REALIZED_BUDGET" : "Gerealiseerd budget",
  "INCOME" : "inkomen",
  "REALIZED" : "Gerealiseerd",
  "ADJUSTMENT" : "Aanpassing",
  "NO_CONFIG_DONE" : "Er is geen configuratie uitgevoerd",
  "CHANGE_FILTER_WITHOUT_SAVING" : "  Je riskeert je niet geredde configuratie te verliezen, wil je doorgaan? ",
  "reminders" : "Herinneringen",
  "revivals" : "Opwekkingen",
  "QUIT" : "ontslag nemen",
  "import_manuel" : "Handmatig importeren",
  "import_automatic" : "Automatisch importeren",
  "DELETE_CONFIGURATION" : "De configuratie verwijderen",
  "DELETE_CONFIGURATION_QUESTION" : "Wilt u deze configuratie echt verwijderen?",
  "RESUME_SUBSCRIPTION" : "hervat mijn abonnement",
  "CANCEL_DOCUMENT" : "de bestelling annuleren",
  "ORDER_CANCELLATION_MESSAGE" : "de bestelling is geannuleerd",
  "ORDER_CANCELLATION_CONFIRM" : "Wilt u deze bestelling annuleren ?",
  "IS_CANCELED" : "geannuleerd",
  "UPDATE_CONFIGURATION_QUESTION" : "Wilt u deze configuratie echt bewerken?",
  "EDIT" : "bewerking",
  "CODA_FILES" : "Coda-bestanden",
  "VIEW_CODA_FILES" : "Coda-bestanden bekijken",
  "CODA_FILES_RECONCILED" : "Coda-bestanden afgestemd",
  "EDIT_CODA_FILES" : "Afgestemde codas verrijken",
  "EDIT_CODA_FILE" : "Verrijk Coda-bestand",
  "CODA_FILE_NAME" : "Coda-bestandsnaam",
  "RECONCILED_PAYMENTS" : "Alle betalingen worden afgestemd",
  "RECONCILE_PAYMENTS" : "Betalingen afstemmen",
  "START_BALANCE" : "Oorspronkelijk saldo ",
  "END_BALANCE" : "Eindsaldo",
  "ACCOUNT" : "Alle rekeningen",
  "ENRICHED_CODA_FILES" : "Verrijkte codas",
  "NOT_ENRICHED_CODA_FILES" : "Niet verrijkte codas",
  "MANGOPAY_ACCOUNT" : "Mangopay account",
  "IS_CODA_FILE_MODIFIED" : "Verrijkte coda bestand",
  "EDIT_ALL_CODA_FILES" : "Verrijk alle Coda-bestanden",
  "DOWNLOAD_CODA_FILE_IN_ZIP_FORMAT": "Download coda-bestanden in zip-formaat",
  "DOWNLOAD_SEPA" : "Het SEPA-bestand downloaden",
  "address_line2": "Adres 2:",
  "order_number": "Uw referenties",
  "another_infos": "Zie meer informatie",
  "SUBSCRIBER": "abonnees",
  "SUBSCRIBERS": "abonnee",
  "RECURRENCE_COEFF" : "De herhalingscoëfficiënt",
  "NO_RECURRENCE_COEFF_FOR_THIS_YEAR" : "Geen herhalingscoëfficiënt dit jaar omdat het het eerste jaar is.",
  "NEW_REGISTRANTS_TOTAL_NUMBER" : "Totaal aantal nieuwe betalende registranten",
  "NEW_REGISTRANTS" : "Nieuwe registranten",
  "FORMER_REGISTRANTS" : "Voormalige registranten",
  "TOTAL_REGISTRED" : "Totaal geregistreerd",
  "MONTHLY_PREMIUM" : "Maandelijkse premies",
  "YEARLY_PREMIUM" : "Jaarlijkse premies",
  "NUMBER_OF_SAMPLES" : "Aantal monsters",
  "MONTHLY_PREMIUM" : "Maandelijkse premies",
  "YEARLY_PREMIUM" : "Jaarlijkse premies",
  "DOCUMENT_DOWNLOADED" : "Het document is geüpload",
  "COMPARE": "Vergelijken",
  "Cotisation" : "Bijdrage",
  "CA": "Omzet",
  "Type cotisations" : "Type bijdragen",
  "Statutaire" : "Statutair",
  "Fiduciaire" : "Fiduciair",
};



// WEBPACK FOOTER //
// ./app/i18n/nl.js